// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/global.css'

import axios from 'axios'

Vue.prototype.$axios = axios

Vue.use(ElementUI)

Vue.config.productionTip = false

function loadBilibiliSDK () {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = 'https://s1.hdslb.com/bfs/cm/cm-sdk/static/js/track-collect.js'
    script.async = true
    document.body.appendChild(script)
  })
}

// 在Vue实例创建之前加载B站js-sdk
loadBilibiliSDK().then(() => {
  new Vue({
    render: h => h(App)
  }).$mount('#app')
}).catch(error => {
  console.error('Error loading Bilibili SDK:', error)
})
// FastClick.attach(document.body)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js